import { useMutation } from '@apollo/client';

import { AddRoleInput } from '../../apollo/__generated__/graphql';
import { ADD_ROLE } from '../graphql/mutation/addRoleMutation.graphql';

export const useAddRoleMutation = () => {
  const [mutate] = useMutation(ADD_ROLE);

  const addRole = (addRoleInput: AddRoleInput) => {
    mutate({
      variables: {
        addRoleInput,
      },
    });
  };

  return { addRole };
};
